import { defineStore } from 'pinia';
import api from '../../api';

export const useDeviceStore = defineStore('device', {
  state: () => ({
    deviceInfo: {},
    deviceTime: '',
    lagList: [],
    managementIpAddress: '',
    loadingDeviceInfo: false,
    switchSpecialInterface: ''
  }),
  actions: {
    setDeviceInfo(data) {
      this.deviceInfo = data;
    },
    setDeviceTime(data) {
      this.deviceTime = data;
    },
    setVlanList(data) {
      this.vlanList = data;
    },
    setSwitchSpecialInterface(data) {
      this.switchSpecialInterface = data.managementVlan;
    },
    setPortList(data) {
      this.portList = data;
    },
    setInitNetwork(data) {
      this.initNetwork = data;
    },
    queryDeviceInfo(params) {
      if (this.loadingDeviceInfo) return;
      this.loadingDeviceInfo = true;
      return api.device.queryDeviceInfo(params)
        .then(data => {
          if (data.resp.respCode === 0 && data.deviceInfo) {
            this.deviceInfo = data.deviceInfo;
          }
          return data;
        })
        .catch(error => {
          throw error;
        }).finally(() => {
          this.loadingDeviceInfo = false;
        });
    },
    queryDeviceTime(params) {
      return api.device.queryDeviceTime(params)
        .then(data => {
          if (data.resp.respCode === 0 && data.deviceTime) {
            this.deviceTime = data.deviceTime;
          }
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
    rebootOrShutdownDevice(params) {
      return api.device.rebootOrShutdownDevice(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
    updateSystemName(params) {
      return api.device.updateSystemName(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
    updateDeviceDateTime(params) {
      return api.device.updateDeviceDateTime(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
    updateSntpService(params) {
      return api.device.updateSntpService(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
    queryLinkAggregation(params) {
      return api.device.queryLinkAggregation(params)
        .then(data => {
          if (data.resp.respCode === 0) {
            this.setLagList(data.switchConfigLagGroup)
          }
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
    setLagList(data){
      this.lagList = data;
    },
    updateLinkAggregation(params) {
      return api.device.updateLinkAggregation(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
    deleteLinkAggregation(params) {
      return api.device.deleteLinkAggregation(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
    querySntpService(params) {
      return api.device.querySntpService(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
    queryCableTest(params) {
      return api.device.queryCableTest(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
    updateFanMode(params) {
      return api.device.updateFanMode(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
    updateBridgePriority(params) {
      return api.device.updateBridgePriority(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
    querySpecialRouteInfo(params) {
      return api.device.querySpecialRouteInfo(params)
        .then(data => {
          if (data.resp.respCode === 0 && data.switchSpecialInterface) {
            this.setSwitchSpecialInterface(data.switchSpecialInterface);
          }
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
    setManagementIpAddress(data){
        let [manage] = data?.filter(item => !!item.management);
        this.managementIpAddress = manage?.ip || '';
    },
    updateSpecialRoute(params) {
      return api.device.updateSpecialRoute(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
    queryVlanRouteInfo(params) {
      return api.device.queryVlanRouteInfo(params)
        .then(data => {
          if (data.resp.respCode == 0) {
            this.setManagementIpAddress(data.switchVlanInterface);
          } else {
            // $sakura.sakuraMessage(data.resp.respCode);
          }
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
    updateVlanRoute(params) {
      return api.device.updateVlanRoute(params)
        .then(data => {
          return data;
        })
        .catch(error => {
          throw error;
        });
    },
  },
});

